import { render, staticRenderFns } from "./RoleChip.vue?vue&type=template&id=0aafc6e8&"
import script from "./RoleChip.vue?vue&type=script&lang=js&"
export * from "./RoleChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports